module.exports = __webpack_public_path__ + "static/media/deputy-shapovalyuk.b6ca2875.jpg";